<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="排班名称">
          <el-input placeholder="请输入排班名称" v-model="formInline.search">
           
          </el-input>
        </el-form-item>

        <el-form-item label="第几学期">
          <el-input placeholder="请输入第几学期" v-model="formInline.term">
          </el-input>
        </el-form-item>

        <el-form-item label="教师名称/ID">
          <el-input placeholder="请输入教师名称/ID" v-model="formInline.name">
          </el-input>
        </el-form-item>

        <el-form-item label="类型：" prop="type" >
      <el-select v-model="formInline.type" >
        <template >
          <el-option :value="-1" label="全部"></el-option>
          <el-option :value="1" label="正课（单词课）"></el-option>
          <el-option :value="2" label="正课（语法阅读课）"></el-option>
          <el-option :value="3" label="复习课"></el-option>
        
        </template>
      </el-select>
    </el-form-item>  

        <el-form-item >
          <el-button   type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button    icon="el-icon-search" @click="reast">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加排班</el-button>
      <el-button size="small" icon="el-icon-del" style="border:1px solid #e81919; background: #e81919;" type="primary" @click="deleteAllClick">一键删除</el-button>
    </div>

    <div class="common-level-rail">
      <el-button size="small" type="success" @click="importOrder"  >导入</el-button>
       
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" @selection-change="handleSelectionChange"  border style="width: 100%" v-loading="loading">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="coc.name" label="教师"></el-table-column>
            <el-table-column prop="term" label="标题"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="year" label="年份"></el-table-column>
            <el-table-column prop="remark" label="介绍"></el-table-column>
            <el-table-column prop="type_val" label="类型"></el-table-column>
  
            <el-table-column prop="status" label="是否开启">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" 
        
                active-color="#13ce66" inactive-color="#ff4949" 
                @change="isDefaultChange(scope.row)"></el-switch>
           
              </template>

            </el-table-column>

            
            <!-- <el-table-column prop="status" label="是否完结">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.fstatus" 
        
                active-color="#13ce66" inactive-color="#ff4949" 
                @change="isDefaultChangef(scope.row)"></el-switch>
           
              </template>

            </el-table-column> -->
  
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

       <!-- 上传导入组件  -->
       <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :workforce_id="workforce_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  </div>
</template>

<script>
  import WorkforceApi from '@/api/workforce.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Upload from '@/components/file/import'
  export default {
    components: {
      Add,
      Edit,
      Upload,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          name:"",
          term:"",
          type:-1
        },

        open_add:false,
        open_edit:false,
        workforce_id:"",
              /*选中的*/
      multipleSelection: [],
      /*选择的会员列表*/
      select_list: [],
      open_upload:false,
      import_type:'workforce',
      };
    },
    created() {
      this.formInline.name = this.$route.query.coc_id;
      /*获取列表*/
      this.getTableList();
    },
    methods: {
        // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
       /*关闭弹窗*/
       closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else if (f == 'detail') {
            this.open_detail = e.openDialog;
        }
    },
       /*选择会员*/
    handleSelectionChange(e) {
      console.log(e);
      this.multipleSelection = e;
    },
          /* 设置默认 */
    isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        WorkforceApi.setStatus({workforce_id: row.workforce_id,status:status}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
    
      })
    },
    isDefaultChangef(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        let fstatus = 1;
        if(row.status){
          fstatus = 1;
        }else{
          fstatus = 0;
        }
        WorkforceApi.setStatusf({workforce_id: row.workforce_id,fstatus:fstatus}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
    
      })
    },
      reast(){
        this.  formInline={
          search:"",
          name:"",
          term:""
        }
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        WorkforceApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==0?false:true;
            }
           
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.workforce_id = row.workforce_id;
        this.open_edit = true
      },
      deleteAllClick(){
        if(this.multipleSelection.length <= 0){
          self.$message({
                    message: '请选择要删除的排班',
                    type: 'info'
                  });
                  return;
        }
        var ids = [];
        this.multipleSelection.forEach(function(res){
          ids.push(res.workforce_id);
        })
        let self = this;
        self
          .$confirm('此操作将永久删除这些记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            if(Array.isArray(ids)){
              ids = JSON.stringify(ids);
            }
            WorkforceApi.del(
              {
                workforce_id: ids
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            WorkforceApi.del(
              {
                workforce_id:  JSON.stringify([ row.workforce_id])
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/workforce/workforce/index.vue